<div id="welcomeBackPopup" class="welcome-popup {{ additionalClasses }}">
  <div class="topBlock">
    <div class="topText">Important Notice</div>
    <div id="imgDiv">
      <img src="../../../../../assets/images/important-notice-icon.webp" loading="lazy" />
    </div>
    <div class="botText">
      Please note – iCreditWorks only offers<br />
      access to loans of <span class="font-weight-bold">{{modalPopups.hawaiiMinAmount}}</span> or greater in<br />
      the <span class="font-weight-bold">state of Hawaii.</span>
    </div>
    <!-- <div *ngIf="isMobile" class="botText">
      iCreditWorks only offers access to loans<br />
      of <span class="font-weight-bold">$1,600</span> or greater in the state of Hawaii.<br />
      Please enter an amount of at least <span class="font-weight-bold">$1,600</span><br />
      in the Estimated Treatment Amount.
    </div> -->
  </div>

  <div class="OKbtn btn btn-size_normal btn-primary a-self-center" (click)="close()">OK</div>
</div>
